// import { Button } from '@mui/material';
// import { AccountBalance } from '@mui/icons-material';
// import { toast } from 'react-toastify';
// import ApiCaller from '../../constants/ApiCaller';
// import urls from '../../constants/apiurl';
// import axios from 'axios';
// import { useSelector } from 'react-redux';
// import { useState } from 'react';


// export const PayoutButton = ({ eventId }) => {
//     const [loading, setLoading] = useState(false);

//     const userData = useSelector((state) => state?.userData);


//     const handlePayout = async () => {
//         try {
//             if (loading) return;
//             setLoading(true);

//             const payload = { eventId };


//             // 👇 Correct usage based on your ApiCaller.js
//             const res = await ApiCaller.post(
//                 payload,
//                 urls.topInviterEventPayout,
//                 userData?.access_token
//             );

//             const data = await res.response.json();

//             if (res.status === 200) {
//                 toast.success(data?.data?.message || "Payout processed successfully!");
//             } else {
//                 toast.error(data?.message || "Failed to process payout.");
//             }

//         } catch (error) {
//             console.error("Error during payout:", error);
//             toast.error("Something went wrong while processing payout.");
//         }
//         finally{
//             setLoading(false); 
//         }
//     };


//     return (
//         <Button
//             startIcon={<AccountBalance />}
//             color="primary"
//             variant="contained"
//             onClick={handlePayout}
//         >
//             Payout
//         </Button>
//     );
// };



import { Button } from '@mui/material';
import { AccountBalance } from '@mui/icons-material';
import { toast } from 'react-toastify';
import ApiCaller from '../../constants/ApiCaller';
import urls from '../../constants/apiurl';
import { useSelector } from 'react-redux';
import { useRef } from 'react';

export const PayoutButton = ({ eventId, disabled }) => {
  const userData = useSelector((state) => state?.userData);
  const calledRef = useRef(false); // 🛡️ prevents double API calls in dev
console.log(disabled)
  const handlePayout = async () => {
    if (disabled || calledRef.current) return; // block if parent disables or already called
    calledRef.current = true;

    try {
      const payload = { eventId };
      const res = await ApiCaller.post(payload, urls.topInviterEventPayout, userData?.access_token);
      const data = await res.response.json();

      if (res.status === 200) {
        toast.success(data?.data?.message || "Payout processed successfully!");
      } else {
        toast.error(data?.message || "Failed to process payout.");
      }
    } catch (error) {
      console.error("Error during payout:", error);
      toast.error("Something went wrong while processing payout.");
    } finally {
      calledRef.current = false; // allow future clicks
    }
  };

  return (
    <Button
      startIcon={<AccountBalance />}
      color="primary"
      variant="contained"
      onClick={handlePayout}
      disabled={disabled}
    >
      {disabled ? "Payout Already Done" : "Payout"}
    </Button>
  );
};
